import React from "react";
import { Family, 

        Adminstrator, 
        Investment,
        Assoociate,
        Seller,
    } from "./Rolle"
import { elakayAutoText, getElakayLanguageContext } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["transferMoneyModal"]?.[key] || fallback;

const transferStyles = `
.transfer-table {
  width: 100%;

  padding: 25px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.10);
  font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.transfer-table h2 {
  text-align: center;
  margin-bottom: 20px;
  font-weight: 700;
  color: #2a2a2a;
}

.transfer-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.transfer-table th {
  text-align: left;
  padding-bottom: 8px;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #eee;
}

.transfer-table td {
  padding: 10px 0;
  color: #333;
}

.transfer-table .sub {
  font-size: 12px;
  color: #888;
}

.transfer-table .highlight td {
  background: #f5f9ff;
  font-weight: 600;
  border-radius: 6px;
}

.transfer-table .amount-row td {
  padding-top: 15px;
  border-top: 1px solid #eee;
  font-size: 16px;
}

.transfer-table .zero {
  color: #ff0606ff;
}

.transfer-table .btn-row {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

.transfer-table .cancel,
.transfer-table .transfer {
  padding: 10px 22px;
  border-radius: 25px;
  font-size: 14px;
  border: none;
  cursor: pointer;
}

.transfer-table .cancel {
  background: #f0f4ff;
  color: #4764ff;
}

.transfer-table .transfer {
  background: #4764ff;
  color: #fff;
  box-shadow: 0 4px 10px rgba(71, 100, 255, 0.25);
}
`;


const TransferMoneyModal = ({
 infoSource,
 sumAll = ()=> null,
setFiltOrders,
  setShowFilterOrder,
  buyerCommission = 0,
  sellerCommission = 0,
  sellerPromotion = 0,
  salesIncome = 0,
  onCancel,
  onTransfer,
}) => {
  __setElakayInfoSource(infoSource);
     let incomme = sumAll(salesIncome, sellerCommission, sellerPromotion, buyerCommission);
     
  return (
    <>
      {/* CSS intégré directement dans la page React */}
      <style>{transferStyles}</style>

      <div className="transfer-table">
        <h2>{infoSource.laguangeElakay('title', infoSource.languageAPI).moneyTransfer}</h2>
<div className="btn btn-dark btn-md py-1 mb-4 rounded-4" onClick={()=> setShowFilterOrder(prev => !prev)}>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).transferMoneyModal.t001}</div> 
        <table>
          <thead>
            <tr>
              <th>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).transferMoneyModal.t002}</th>
              <th>{infoSource.laguangeElakay('label', infoSource.languageAPI).amount}</th>
            </tr>
          </thead>

          <tbody>
           {Assoociate() && buyerCommission !== 0 && <tr>
              <td>{__elakayText("t006", "commission for my buyer")}{/* <br /> */}
                {/* <span className="sub">{} orders;</span> */}
              </td>
              
              <td>${incomme.buyerCommission}</td>
            </tr>}

            {Assoociate() &&  sellerPromotion !== 0 && <tr>
              <td>{__elakayText("t007", "commission for my Promotion")}{/* <br />
                <span className="sub">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).transferMoneyModal.t003}</span> */}
              </td>
              <td>${incomme.sellerPromotion}</td>
            </tr>}

           {Assoociate() && sellerCommission !== 0 && <tr>
              <td>{__elakayText("t008", "commission for my seller")}<br />
                <span className="sub">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).transferMoneyModal.t004}</span>
              </td>
              <td>${incomme.sellerCommission}</td>
            </tr>}



            <tr className="highlight">
              <td>
                <strong>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).transferMoneyModal.t005}</strong>
              </td>
              <td>
                <strong>${incomme.salesIncome}</strong>
              </td>
            </tr>

            <tr className="amount-row">
              <td>
                <strong>{infoSource.laguangeElakay('label', infoSource.languageAPI).amount}</strong>
              </td>
              <td className="zero">
                ${incomme.total}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="btn-row">
          <button className="cancel" onClick={onCancel}>{elakayAutoText("h_1507c40f043249", "CANCEL")}</button>
          <button className="transfer" onClick={onTransfer}>{elakayAutoText("h_0bceb06cae8983", "TRANSFER")}</button>
        </div>
      </div>
    </>
  );
};

export default TransferMoneyModal;
